import { GraphQL } from '@guestgoodie/graphql'
import * as Tooltip from '@radix-ui/react-tooltip'
import { HugeiconsIcon } from '@hugeicons/react'
import { InformationSquareIcon } from '@hugeicons/core-solid-rounded'
import { Trans } from '@lingui/react/macro'
import { dateTime } from '@guestgoodie/helpers'

import { useUser } from '@/features/user'
import { tooltipContainer } from '@/utils/popovers'
import { Suspense } from '@/components/ui/Suspense'

function Content({ item }: { item: GraphQL.SimpleFeedbackFragmentFragment }) {
  const user = useUser(item.readByUserId ?? null)

  return (
    <div className="flex flex-col gap-2">
      {user && (
        <div className="flex flex-col">
          <span className="text-heading3">
            <Trans>Read by</Trans>
          </span>
          <span>
            {user.givenName} {user.lastName}
          </span>
        </div>
      )}
      {item.readAt && (
        <div className="flex flex-col">
          <span className="text-heading3">
            <Trans>Read at</Trans>
          </span>
          <span>
            {dateTime.fullFormatterCurrentTimezone.format(
              new Date(item.readAt)
            )}
          </span>
        </div>
      )}
    </div>
  )
}

export function ReadIcon({
  item
}: {
  item: GraphQL.SimpleFeedbackFragmentFragment
}) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger className="rounded-xxsmall">
        <div className="flex flex-row items-center">
          <HugeiconsIcon
            icon={InformationSquareIcon}
            className="size-5 text-text"
          />
        </div>
      </Tooltip.Trigger>
      <Tooltip.Portal container={tooltipContainer}>
        <Tooltip.Content
          collisionPadding={20}
          className="flex flex-col gap-1 rounded-small bg-black/70 p-2 text-white z-tooltip"
          style={{
            maxWidth: 'var(--radix-tooltip-content-available-width)'
          }}
          sideOffset={5}
        >
          <Suspense>
            <Content item={item} />
          </Suspense>
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  )
}
